import appsettings from '../../appsettings.json';

export const environment = {
  production: false,
  title: 'Local Environment',
  urls: {
    baseUrl: appsettings['MAPP-FRONTEND-BASE-URL'],
    localBaseUrl: appsettings['LOCALHOST-BASE-URL'],
    apiBaseUrl: appsettings['MAPP-FRONTEND-SERVICES-BASE-URL'],
    lighthouseBaseUrl: appsettings['MAPP-FRONTEND-PORTAL-BASE-URL'],
  },
};
